/**
 *
 * BlockTab
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Badge, Button } from 'react-bootstrap';
import { format, SHORTDATE } from 'utils/date-fns/index.js';

const Wrapper = styled(Button).attrs({ variant: 'link' })`
  &.btn {
    .badge {
      margin-right: 1rem;
    }
    &[disabled], &[disabled]:hover {
      color: ${(p) => p.theme.brandPrimary};
      border-bottom: 2px solid ${(p) => p.theme.brandPrimary};
      opacity: 1;
    }
  }
`;

function BlockTab(props) {
  const { date, blocks, onClick, disabled } = props;
  const count = blocks.reduce((sum, block) => sum + block.availableSlots, 0);
  return (
    <Wrapper disabled={disabled} onClick={onClick}>
      <Badge>{count}</Badge>
      {format(date, SHORTDATE)}
    </Wrapper>
  );
}

BlockTab.propTypes = {
  date: PropTypes.object,
  blocks: PropTypes.array,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default BlockTab;
